<!---->
<template>
  <div class="container">
    <div class="content-wrapper">
      <!-- 文章列表 -->
      <div v-if="!showDetail" class="article-list" v-loading="loading">
        <div
            v-for="article in articles"
            :key="article.id"
            class="article-card"
            @click="handleArticleClick(article)"
        >
          <div class="article-image">
            <img v-if="article.image" :src="article.image" :alt="article.title" />
            <div v-else class="article-image-placeholder">
              <span>暂无图片</span>
            </div>
          </div>
          <div class="article-content">
            <h3 class="article-title">{{ article.title || '无标题' }}</h3>
            <p class="article-summary">{{ article.summary || '暂无描述' }}</p>
            <div class="article-meta">
              <span class="article-date">{{ article.date }}</span>
            </div>
          </div>
        </div>
        <!-- 空状态 -->
        <div v-if="!loading && articles.length === 0" class="empty-state">
          <p>暂无数据</p>
        </div>
        <!-- 查看更多按钮 -->
        <div v-if="hasMore && !loading" class="load-more-wrapper">
          <button class="load-more-button" @click="loadMore" :disabled="loadingMore">
            <span v-if="!loadingMore">查看更多</span>
            <span v-else>加载中...</span>
          </button>
        </div>
      </div>

      <!-- 文章详情 -->
      <div v-else class="article-detail" v-loading="detailLoading">
        <div class="detail-header">
          <button class="back-button" @click="goBackToList">
            <el-icon><ArrowLeft /></el-icon>
          </button>
        </div>
        <div v-if="articleDetail" class="detail-content">
          <div class="detail-body" v-html="articleDetail.content"></div>
          <div v-if="!articleDetail.content" class="empty-content">
            <p>暂无内容</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
  min-height: calc(100vh - 11rem);
}

.content-wrapper {
  margin: auto;
  width: 90%;
  max-width: 1200px;
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.article-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.article-card {
  display: flex;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  height: 220px;
}

.article-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.article-image {
  flex-shrink: 0;
  width: 300px;
  height: 220px;
  overflow: hidden;
}

.article-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  font-size: 0.9rem;
}

.article-content {
  flex: 1;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.article-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-summary {
  font-size: 0.8rem;
  color: #666;
  line-height: 1.6;
  margin: 0 0 1rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-height: 3.84rem;
  min-height: 0;
}

.article-meta {
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 0.85rem;
  color: #999;
}

.article-date {
  color: #999;
}

.article-category {
  background: #f0f0f0;
  color: #666;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #999;
  font-size: 1rem;
}

.load-more-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  padding: 2rem 0;
}

.load-more-button {
  padding: 0.5rem 2rem;
  background: transparent;
  color: #333;
  border: 1px solid #333;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.load-more-button:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #666;
  color: #000;
}

.load-more-button:disabled {
  background: transparent;
  border-color: #ccc;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 文章详情样式 */
.article-detail {
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  width: 50rem;
  margin: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.detail-header {
  margin-bottom: 2rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #666;
  transition: all 0.3s ease;
}

.detail-description p {
  margin: 0;
}

.detail-image {
  margin-bottom: 2rem;
  text-align: center;
}

.detail-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.detail-body {
  margin-top: 2rem;
  font-size: 1rem;
  line-height: 1.8;
  color: #333;
}

.detail-body :deep(p) {
  margin: 1rem 0;
}

.detail-body :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1rem 0;
}

.detail-body :deep(h1),
.detail-body :deep(h2),
.detail-body :deep(h3) {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.empty-content {
  text-align: center;
  padding: 4rem 2rem;
  color: #999;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .article-card {
    flex-direction: column;
    height: auto;
  }

  .article-image {
    width: 100%;
    height: 200px;
  }

  .detail-title {
    font-size: 1.5rem;
  }

  .article-detail {
    padding: 1rem;
  }
}
</style>
<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { ArrowLeft } from '@element-plus/icons-vue';

// API 基础地址
const API_BASE_URL = process.env.VUE_APP_WEB_URL;

// 文章列表数据
const articles = ref([]);
// 加载状态
const loading = ref(false);
// 是否显示详情
const showDetail = ref(false);
// 文章详情数据
const articleDetail = ref(null);
// 详情加载状态
const detailLoading = ref(false);
// 当前页码
const currentPage = ref(1);
// 总数据量
const total = ref(0);
// 每页数量
const pageSize = 10;
// 加载更多状态
const loadingMore = ref(false);

// 格式化日期
function formatDate(dateString) {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    return '';
  }
}

// 判断是否还有更多数据
const hasMore = computed(() => {
  return articles.value.length < total.value;
});

// 获取技术文章列表
async function loadTechnologyList(page = 1, append = false) {
  if (append) {
    loadingMore.value = true;
  } else {
    loading.value = true;
  }
  try {
    const res = await axios.get(`${API_BASE_URL}/website/getTechnology/${page}/${pageSize}`);
    if (res.data && res.data.code === 200) {
      const records = res.data.data?.records || [];
      // 保存总数
      total.value = res.data.data?.total || 0;
      // 映射数据格式
      const mappedRecords = records.map((item) => ({
        id: item.id,
        title: item.title || '无标题',
        summary: item.description || '暂无描述',
        // 优先使用 cover，如果没有则使用 image
        image: item.cover || item.image || '',
        date: formatDate(item.createTime)
      }));
      
      if (append) {
        // 追加数据
        articles.value = [...articles.value, ...mappedRecords];
      } else {
        // 替换数据
        articles.value = mappedRecords;
      }
    } else {
      ElMessage.error(res.data?.message || '获取数据失败');
    }
  } catch (error) {
    console.error('获取技术文章列表失败:', error);
    ElMessage.error('获取数据失败，请稍后重试');
  } finally {
    loading.value = false;
    loadingMore.value = false;
  }
}

// 加载更多
async function loadMore() {
  if (loadingMore.value || !hasMore.value) return;
  
  currentPage.value += 1;
  await loadTechnologyList(currentPage.value, true);
}

// 获取文章详情
async function loadArticleDetail(id) {
  detailLoading.value = true;
  try {
    const res = await axios.get(`${API_BASE_URL}/website/data/${id}`);
    if (res.data && res.data.code === 200) {
      articleDetail.value = res.data.data;
    } else {
      ElMessage.error(res.data?.message || '获取文章详情失败');
    }
  } catch (error) {
    console.error('获取文章详情失败:', error);
    ElMessage.error('获取文章详情失败，请稍后重试');
  } finally {
    detailLoading.value = false;
  }
}

// 点击文章处理函数
async function handleArticleClick(article) {
  showDetail.value = true;
  articleDetail.value = null;
  await loadArticleDetail(article.id);
}

// 返回列表
function goBackToList() {
  showDetail.value = false;
  articleDetail.value = null;
}

// 页面加载时获取数据
onMounted(() => {
  currentPage.value = 1;
  loadTechnologyList(1, false);
});
</script>